var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserbadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "50 -Blank Profile- (Outline)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-1200.000000, -850.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "50--Blank-Profile--(Outline)",
    transform: "translate(1200.000000, 850.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,2 C14.561,2 2,14.561 2,30 C2,45.439 14.561,58 30,58 C45.439,58 58,45.439 58,30 C58,14.561 45.439,2 30,2 M30,60 C13.458,60 0,46.542 0,30 C0,13.458 13.458,0 30,0 C46.542,0 60,13.458 60,30 C60,46.542 46.542,60 30,60",
    id: "Fill-293"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,15 C25.589,15 22,18.589 22,23 C22,27.411 25.589,31 30,31 C34.411,31 38,27.411 38,23 C38,18.589 34.411,15 30,15 M30,33 C24.486,33 20,28.514 20,23 C20,17.486 24.486,13 30,13 C35.514,13 40,17.486 40,23 C40,28.514 35.514,33 30,33",
    id: "Fill-298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,56.3984 C43.447,56.3984 43,55.9504 43,55.3984 L43,48.0004 C43,43.6044 40.732,39.4764 37.045,37.0894 C32.762,39.5934 27.238,39.5934 22.955,37.0894 C19.268,39.4764 17,43.6044 17,48.0004 L17,55.3984 C17,55.9504 16.553,56.3984 16,56.3984 C15.447,56.3984 15,55.9504 15,55.3984 L15,48.0004 C15,42.6994 17.854,37.7374 22.45,35.0524 C22.776,34.8624 23.182,34.8724 23.498,35.0754 C27.391,37.5934 32.609,37.5934 36.502,35.0754 C36.819,34.8724 37.224,34.8624 37.55,35.0524 C42.146,37.7374 45,42.6994 45,48.0004 L45,55.3984 C45,55.9504 44.553,56.3984 44,56.3984",
    id: "Fill-299"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserbadge);
export default __webpack_public_path__ + "static/media/userbadge.5ecd9c619725d8699d3f6a4be48b4880.svg";
export { ForwardRef as ReactComponent };